import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.188 17.507H2.813a.188.188 0 0 0-.188.188v1.312c0 .103.084.188.188.188h18.375a.188.188 0 0 0 .187-.188v-1.312a.188.188 0 0 0-.188-.188zM3.884 14.573l.93.926a.188.188 0 0 0 .265 0l5.5-5.482 2.288 2.28a.752.752 0 0 0 1.06 0l6.192-6.169a.188.188 0 0 0 0-.265l-.93-.928a.188.188 0 0 0-.266 0L13.4 10.443l-2.29-2.28a.753.753 0 0 0-1.059 0l-6.166 6.145a.186.186 0 0 0 0 .265z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }